import * as styles from "./TabsPanel.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Tabs as BaseTabs } from "@base-ui/react/tabs";

import type { TabsPanelProps } from "./Tabs.types";

export function TabsPanel({
  className,
  keepMounted = true,
  ...props
}: TabsPanelProps): JSX.Element {
  return (
    <BaseTabs.Panel
      data-slot="tabs-panel"
      keepMounted={keepMounted}
      className={clsx(styles.panel, className)}
      {...props}
    />
  );
}
